import { ESignProvider } from '@dealstack/shared/lib/generated';

/**
 * Authorised signatory functionality was only built for eID Easy signature
 * workflows. Anything else is out of scope, so the
 * invite / resend controls must not appear for those documents — otherwise the
 * signature workflow would be routed into a flow the document cannot complete.
 */
export const isAuthorisedSignatorySupported = (
	eSignProvider: ESignProvider | null | undefined
): boolean => eSignProvider === ESignProvider.EID_EASY;
